import { render, staticRenderFns } from "./OneRelatedProducts.vue?vue&type=template&id=19235dd5&scoped=true&lang=pug&"
import script from "./OneRelatedProducts.vue?vue&type=script&lang=ts&"
export * from "./OneRelatedProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19235dd5",
  null
  
)

export default component.exports